module.exports = __webpack_public_path__ + "static/media/cruz.84b6a224.png";